import React, { useState, useEffect } from "react";

interface ConfirmModalProps {
	open: boolean;
	title: string;
	message?: string;
	confirmLabel?: string;
	loading?: boolean;
	showReason?: boolean;
	requireReason?: boolean;
	onConfirm: (reason?: string) => void;
	onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
	open,
	title,
	message,
	confirmLabel = "実行する",
	loading = false,
	showReason = true,
	requireReason = true,
	onConfirm,
	onCancel,
}) => {
	const [reason, setReason] = useState("");

	useEffect(() => {
		if (!open) setReason("");
	}, [open]);

	if (!open) return null;

	const disabled =
		loading || (showReason && requireReason && reason.trim().length === 0);

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
			<div className="w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl">
				<h3 className="text-lg font-semibold text-ink">{title}</h3>
				{message && <p className="mt-2 text-sm text-muted">{message}</p>}

				{showReason && (
					<div className="mt-4">
						<label className="text-xs font-semibold text-muted">
							理由 (監査用)
						</label>
						<textarea
							value={reason}
							onChange={(e) => setReason(e.target.value)}
							className="mt-1 w-full rounded-xl border border-surface-border bg-surface-alt px-3 py-2 text-sm focus:border-primary focus:outline-none"
							rows={3}
							placeholder="操作理由や問い合わせ番号を残してください"
						/>
					</div>
				)}

				<div className="mt-6 flex justify-end gap-2">
					<button
						onClick={onCancel}
						className="rounded-lg border border-surface-border px-3 sm:px-4 py-2 text-sm font-semibold text-muted transition hover:text-ink"
					>
						キャンセル
					</button>
					<button
						disabled={disabled}
						onClick={() => onConfirm(reason)}
						className="rounded-lg bg-primary px-3 sm:px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-strong disabled:cursor-not-allowed disabled:opacity-50"
					>
						{loading ? "送信中..." : confirmLabel}
					</button>
				</div>
			</div>
		</div>
	);
};

export default ConfirmModal;
